module.exports = __webpack_public_path__ + "f69248de482552af06f02da3a5ffd780.woff2";